import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Define the initial state
const initialState = {
    links: [],
    loading: false,
    error: null,
};

// Create an async thunk for deleting a link
export const deleteLink = createAsyncThunk(
    'twitterLink/deleteLink',
    async (linkId, { rejectWithValue }) => {
        const user = localStorage.getItem('user');
        let token;
        if (user) {
            const parsedUser = JSON.parse(user);
            token = parsedUser.auth;
        }
        if (!token) {
            throw new Error('No authentication token found');
        }
        try {
            // Include the headers in the axios request
            await axios.delete(`${process.env.REACT_APP_API_ENDPOINT_URL}/twitter/link/delete/${linkId}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            });
            return linkId; // Return the linkId to remove it from the state
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// Create the slice
const twitterLinkSlice = createSlice({
    name: 'twitterLink',
    initialState,
    reducers: {
        setLinks: (state, action) => {
            state.links = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(deleteLink.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(deleteLink.fulfilled, (state, action) => {
                state.loading = false;
                state.links = state.links.filter(link => link.id !== action.payload);
            })
            .addCase(deleteLink.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

// Export the actions and reducer
export const { setLinks } = twitterLinkSlice.actions;
export default twitterLinkSlice.reducer;